<template>
	<div class="">
		<base-page-heading
			title="PDPs"
			subtitle=""
			class="d-print-none"
		>
			<template #extra>
				<b-button
					ref="pdpShow"
					type="submit"
					size="md"
					variant="secondary"
					@click="showModal"
				>
					<i class="fa fa-fw fa-plus" /> 	Create new
				</b-button>
			</template>
		</base-page-heading>

		<div class="row">
			<PdpTable
				@routePdp="routePdp"
			/>
		</div>
	</div>
</template>
